<template>
  <div class="animated fadeIn row">
    <div class="card w-full">
      <div class="card-header">
        <strong><span v-bind:class="'flag-icon flag-icon-us'" v-if="data.article.lang=='en'"></span><span v-bind:class="'flag-icon flag-icon-'+data.article.lang"
            v-if="data.article.lang!='en'"></span> บทความ : {{data.article.title}}</strong>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <label v-if="data.article.created_at">&nbsp;&nbsp;<b>วันที่สร้าง:</b> {{ data.article.created_at |
                moment('timezone', 'Asia/Bangkok', 'LLLL')}}</label>
              <label v-if="data.article.updated_at">&nbsp;&nbsp;<b>วันที่แก้ไข:</b> {{ data.article.updated_at |
                moment('timezone', 'Asia/Bangkok', 'LLLL')}}</label>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="form-group row" v-if="data.article.image!=''">
            <div class="offset-lg-1 col-lg-10 text-center">
              <img v-bind:src="data.article.image" @error="imageLoadError" class="d-block w-full">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <p v-html="data.article.content"></p>
            </div>
          </div>
        </div>
        <div class="row mb-2" v-if="article.categories.selected.length>0">
          <div class="col-sm-12">
            <b>หมวดหมู่ที่เกี่ยวข้อง</b>
            <div class="row">
              <div v-for="category in article.categories.selected" :key="category.id">
                <b-btn @click="$router.push({ name: 'ArticleList',query: { category_id: category.id }})" class="mt-1 mx-1"
                  size="sm" variant="primary"><span v-html="category.name"></span></b-btn>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="offset-lg-4 col-lg-4">
            <router-link :to="{ name: 'ArticleList'}"><button class="btn btn-info w-full" type="button"><i class="far fa-newspaper"></i>
                ดูบทความอื่นๆ</button></router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueMoment from 'vue-moment'
  import moment from 'moment-timezone'
  Vue.use(VueMoment, {
    moment,
  })
  export default {
    data() {
      return {
        load: 0,
        article: {
          id: parseInt(this.$route.query.id),
          categories: {
            options: [],
            selected: []
          }
        },
        no_image:{
          src: 'https://d2gvpkbpfjsf4i.cloudfront.net/web-builder/no-image.png'
        },
        authorization: 'Bearer '+localStorage.getItem('z_token'),
        data: {
          article: {
            title: '',
            image: '',
            content: '',
            lang: '',
            created_at: '',
            updated_at: '',
            categories: []
          }
        }
      }
    },
    methods: {
      checkLoad() {
        this.load = this.load - 1
        if (this.load <= 0) {
          this.load = 0
          this.$Progress.finish()
        }
      },
      startLoad(count) {
        this.load = count
        this.$Progress.start()
      },
      failLoad() {
        this.$Progress.fail()
      },
      checkCategories() {
        let obj, val;
        for (val in this.data.article.categories) {
          for (obj in this.article.categories.options) {
            if (this.article.categories.options[obj].id == this.data.article.categories[val]) {
              this.article.categories.selected.push(this.article.categories.options[obj])
              break
            }
          }
        }
      },
      getArticleByID(id) {
        this.startLoad(1)
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/articles/' + id, {
          params: {
            lang: this.data.article.lang
          },
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.checkLoad()
          if (response.body.json) {
            this.data.article.title = response.body.json.title
            this.data.article.content = response.body.json.description
            this.data.article.image = response.body.json.image
            this.data.article.lang = response.body.json.locale
            this.data.article.categories = response.body.json.categories
            this.data.article.created_at = response.body.json.created_at
            this.data.article.updated_at = response.body.json.updated_at
            moment.locale(this.data.article.lang)
            this.checkCategories()
          }
        }, response => {
          this.failLoad()
        })
      },
      imageLoadError(event){
        this.data.article.image = ''
        event.target.src = this.no_image.src
      },
      getCategories() {
        this.startLoad(1)
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/categories', {
          params: {
            lang: this.data.article.lang,
            per_page: 100
          },
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.article.categories.options = response.body.json.data
          if (Number.isInteger(this.article.id)) {
            this.getArticleByID(this.article.id)
          }
          this.checkLoad()
        }, response => {
          this.failLoad()
        });

      }
    },
    mounted() {
      this.getCategories()
    }
  }

</script>
